export default __webpack_public_path__ + "static/media/javascript.1b2759f5.svg";